/**
 * The pre-order badge, on collection cards.
 *
 * Whether a style is on pre-order is a fact about our rules, not about the
 * product, so Liquid cannot know it. One request answers the whole page — a
 * collection has two dozen cards and asking about each would be two dozen round
 * trips for a label.
 *
 * The answer is kept for the session, so moving between collections costs
 * nothing after the first page.
 */
(function () {
  'use strict';

  var KEY = 'tc_preorder_ids_v1';
  var ids = null;

  function remembered() {
    try {
      var raw = sessionStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function remember(list) {
    try { sessionStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function badge(card) {
    var mount = card.querySelector('.tru-product-card__media, .image-cont');
    if (!mount || mount.querySelector('.tru-badge--preorder')) return;
    var tag = document.createElement('span');
    tag.className = 'tru-badge tru-badge--preorder';
    tag.textContent = 'Pre-order';
    mount.appendChild(tag);
  }

  function paint(scope) {
    if (!ids || !ids.length) return;
    var cards = (scope || document).querySelectorAll('[data-product-id]');
    for (var i = 0; i < cards.length; i++) {
      if (ids.indexOf(String(cards[i].getAttribute('data-product-id'))) === -1) continue;
      badge(cards[i]);
      /*
       * And put it back on the page, if the grid was asked to hide sold-out
       * styles. A style taking pre-orders is sold out and very much for sale,
       * and it is the one thing on that grid a customer cannot find anywhere
       * else — hiding it would take the pre-order system off the shop.
       */
      cards[i].classList.add('is-preorderable');
    }
  }

  function boot() {
    if (!document.querySelector('[data-product-id]')) return;

    var saved = remembered();
    if (saved) { ids = saved; paint(); }

    fetch('/apps/tru/preorder-ids', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        ids = (data.productIds || []).map(String);
        remember(ids);
        paint();
      })
      .catch(function () { /* no badge is better than a broken page */ });

    /* Collections replace the grid when a filter is applied. */
    var watcher = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) { paint(); return; }
      }
    });
    if (document.body) watcher.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
